import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { useAtom } from "jotai/react";
import { Fragment, useState } from "react";
import { getUpdateOnboardProcess } from "./storeStates";

function DisplayConnectAccountOnboarding(props) {
  // Embedded Onboard process is set in hatoi
  const [, setConnectedAccountOnboardFinished] = useAtom(getUpdateOnboardProcess); 

  const stripeConnectInstance = props.stripeConnectInstance;
  const [onboardingExited, setOnboardingExited] = useState(false);
  
  const handleOnExit = (event) => {
    if(event.error){
        // Need to handle error here, for now lets just add a state
        setOnboardingExited(true);
    }else{
      // Update atom to trigger useEffect in parent component
      setConnectedAccountOnboardFinished(true);
    }
  }

  return (
    <Fragment>
      {!onboardingExited && stripeConnectInstance && (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
          <ConnectAccountOnboarding onExit={handleOnExit} />
        </ConnectComponentsProvider>
      )}
    </Fragment>
  );
}

export default DisplayConnectAccountOnboarding;
